import styled from "styled-components";
import Outline32CRemove from '@mds/mds-icons/icons/svg/outline-32-c-remove.svg';

const Wrapper = styled.div`
  display: flex;
  height: calc(100vh - 180px);
  .preview-wrapper {
    width: 100%;
    height: 100%;
    z-index: 11;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;

    .preview {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 80vw;
      height: 90vh;
      background: #fff;
      padding: 30px 50px;
      box-sizing: border-box;

      .loadingWrapper {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      }

      object {
        width: 100%;
        height: 100%;
      }

      .close {
        position: absolute;
        background: transparent url('${Outline32CRemove}') no-repeat center;
        background-size: 24px;
        border-radius: 50%;
        opacity: 0.7;
        border: none;
        right: 10px;
        top: 10px;
        width: 32px;
        height: 32px;

        &:hover {
          background: #f2f2f2 url('${Outline32CRemove}') no-repeat center;
          background-size: 24px;
          opacity: 1;
        }
      }

      h1 {
        font-size: 24px;
        font-weight: normal;
      }

      p {
        font-size: 14px;
        margin-top: 10px;
        color: #6c6c6c;
        margin-bottom: 24px;
      }

      .doc {
        flex: 1;
        padding: 0 50px;
        border: solid thin #ccc;
      }

      .buttons {
        margin-top: 24px;
        display: flex;
        justify-content: end;
        gap: 10px;
      }
    }
  }

  .left {
    border-right: solid thin #ccc;
    width: 256px;

    h2 {
      padding: 20px 20px 20px 30px;
    }

    li {
      padding: 20px 20px 20px 25px;
      border-left: 5px solid transparent;
      display: block;
      cursor: pointer;
      font-weight: 100;

      &.active {
        border-left: 5px solid rgb(34, 81, 204);
        background: rgb(230, 236, 255);
      }

      &.disabled {
        opacity: 0.5;
      }

      &:hover {
        background: rgb(242, 242, 242);
      }
    }
  }

  .right {
    flex: 1;
    min-width: 600px;
    background: #fafafa;
    overflow-x: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
    display: flex;
    flex-direction: column;

    .loadingWrapper {
      flex: 1;
      width: 100%;
      min-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    }

    /* Card width comes from Insights grid — keep items shrink-safe */
    .card-container {
      min-width: 0;
      width: auto;

      > * {
        width: 100%;
      }
    }
  }

  .content {
    margin: 20px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    min-width: 0;
    /* Set by Insights.js from ResizeObserver — reflows when zoom / pane width changes */
    --insights-grid-cols: 4;

    .flex {
      display: grid;
      width: 95%;
      max-width: 100%;
      box-sizing: border-box;
      margin: 30px 0;
      gap: clamp(16px, 2vw, 28px);
      grid-template-columns: repeat(var(--insights-grid-cols, 4), minmax(0, 1fr));

      > div {
        min-width: 0;
        transition: 0.4s;

        &:hover {
          transform: translate(0, -4px);
          box-shadow: 0 16px 32px -1px #051c2c33, 0 0 1px #051c2c26;
        }

        .mds-card-image {
          transition: 0.4s;

          img {
            aspect-ratio: 16 / 9;
            object-fit: cover;
            vertical-align: middle;
          }
        }

        .mds-card-title {
          // display : block;
          // white-space : nowrap;
          // text-overflow : ellipsis;
          // overflow : hidden;
        }

        .mds-card-body {
          max-height: 300px;

          .mds-card-content {
            div:last-of-type {
              height: 52px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }

          .mds-card-social {
            margin-top: 1rem;
          }
        }
      }
    }

    h1 {
      font-size: 24px;
      margin-bottom: 20px;
    }

    min-height: calc(100vh - 90px - 60px - 92px);
    box-sizing: border-box;

    > p {
      margin: 20px 0;
      color: #757575;
    }

    button {
      text-align: left;
      font-weight: normal;
    }
  }

`;

export default Wrapper;